import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry } from 'rxjs';

import { CURRENT_SETTINGS } from 'src/configs/settings/current-settings';

/**
 * Intercepts the requests and possibly retries in case of an error (depending on the env specific configuration)
 */
@Injectable()
export class HttpRetryInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(retry(CURRENT_SETTINGS.apis.backend.retryCount || 0));
  }
}
